<template>
  <div class="work-company-name-container">
    <div v-if="hasAISearchPermission" class="label-container">
      <span class="label"></span>
      <div class="include-children-btn">
        <span class="btn-label">{{ $t(`${i18nPrefix}.label.useAiSearch`) }}</span>
        <el-switch v-model="isUseAiSearch" :width="28" @change="handleValueChange"></el-switch>
      </div>
    </div>
    <div class="label-container">
      <span class="label">{{ $t(`${i18nPrefix}.label.workCompanyNameSearch`) }}</span>
      <div class="include-children-btn">
        <span class="btn-label">{{ $t(`${i18nPrefix}.label.currentOnly`) }}</span>
        <el-switch v-model="isLastWork" :width="28" @change="handleValueChange"></el-switch>
      </div>
    </div>
    <div class="input">
      <el-select
        v-bind="props"
        v-on="events"
        v-model="name"
        multiple
        filterable
        default-first-option
        allow-create
        :placeholder="placeholder"
        @input="changeName">
      </el-select>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      required: true
    },
    placeholder: {},
    events: {},
    props: {}
  },
  data () {
    return {
      i18nPrefix: 'admin.application.applicantList',
      isLastWork: true,
      isUseAiSearch: false,
      name: null,
      changeName: null
    }
  },
  computed: {
    hasAISearchPermission () {
      return this.hasAnyPermission(['PERM_AI_CHAT_SEARCH', 'PREMIUM_AI_CHAT_SEARCH'])
    }
  },
  created () {
    this.changeName = _.debounce(this.handleValueChange, 500)
  },
  methods: {
    handleChangeName () {
      this.changeName()
    },
    handleValueChange () {
      const value = {
        isLastWork: this.isLastWork,
        isUseAiSearch: this.isUseAiSearch,
        name: this.name
      }
      this.$emit('change', value)
    }
  },
  watch: {
    value: {
      handler () {
        if (this.value) {
          this.isLastWork = this.value.isLastWork
          this.name = this.value.name
        } else {
          this.isLastWork = true
          this.name = null
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.work-company-name-container {
  .label-container {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    justify-content: space-between;
    color: #606266;

    + .label-container {
      margin-top: -10px;
    }

    .include-children-btn {
      display: inline-block;
      .btn-label {
        font-size: 10px;
        margin-right: 2px;
      }

      ::v-deep {
        .el-switch {
          height: 14px;
          .el-switch__core {
            height: 14px;
            &::after {
              width: 10px;
              height: 10px;
            }
          }

        }
        .is-checked {
          .el-switch__core {
            &::after {
              margin-left: -11px;
            }
          }
        }
      }

    }
  }
}
</style>
